import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { IDS } from "@/constants/testIds";
import { toast } from "sonner";

const NAV = [
  { group: "Gestione", items: [
    { to: "/", icon: "fa-house", label: "Home", key: "home" },
    { to: "/anagrafiche", icon: "fa-address-book", label: "Anagrafiche", key: "anagrafiche" },
    { to: "/clienti", icon: "fa-users", label: "Clienti", key: "clienti" },
    { to: "/magazzino", icon: "fa-boxes-stacked", label: "Magazzino", key: "magazzino" },
    { to: "/movimenti", icon: "fa-right-left", label: "Movimenti", key: "movimenti" },
  ]},
  { group: "Operatività", items: [
    { to: "/ordini", icon: "fa-file-invoice", label: "Ordini", key: "ordini" },
    { to: "/personalizzazioni", icon: "fa-palette", label: "Personalizzazioni", key: "personalizzazioni" },
    { to: "/calendario", icon: "fa-calendar-days", label: "Calendario", key: "calendario" },
    { to: "/impostazioni", icon: "fa-gear", label: "Impostazioni", key: "impostazioni" },
    { to: "/profilo", icon: "fa-user", label: "Profilo utente", key: "profilo" },
  ]},
];

const TITLES = {
  "/": ["Dashboard", "Panoramica operativa del gestionale"],
  "/anagrafiche": ["Anagrafiche", "Prodotti, modelli e fornitori"],
  "/clienti": ["Clienti", "Atleti, società sportive e privati"],
  "/magazzino": ["Magazzino", "Disponibilità per modello, colore e taglia"],
  "/movimenti": ["Movimenti", "Carichi, scarichi e rettifiche"],
  "/ordini": ["Ordini", "Gestione ordini cliente"],
  "/personalizzazioni": ["Personalizzazioni", "Stampe, ricami e applicazioni"],
  "/calendario": ["Calendario", "Eventi sincronizzati con Google Calendar"],
  "/impostazioni": ["Impostazioni", "Backup e manutenzione dei dati"],
  "/profilo": ["Profilo utente", "Gestisci email e password"],
};

export default function Layout({ children, topbarActions = null }) {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const nav = useNavigate();
  const [title, subtitle] = TITLES[loc.pathname] || ["GymERP", ""];

  const doLogout = async () => {
    await logout();
    toast.success("Sessione chiusa");
    nav("/login", { replace: true });
  };

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="brand">
          <div className="brand-mark">G</div>
          <div>
            <strong>GymERP</strong>
            <small>Gymnastic Design · v1.0</small>
          </div>
        </div>
        <div className="nav">
          {NAV.map((g) => (
            <div key={g.group}>
              <div className="nav-title">{g.group}</div>
              {g.items.map((it) => (
                <NavLink
                  key={it.to}
                  to={it.to}
                  end={it.to === "/"}
                  data-testid={`${IDS.navPrefix}${it.key}`}
                  className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
                >
                  <i className={`fa-solid ${it.icon}`} /> <span>{it.label}</span>
                </NavLink>
              ))}
            </div>
          ))}
        </div>
        <div className="sidebar-user">
          Connesso come<br />
          <b data-testid="sidebar-user-email">{user?.email || "—"}</b>
        </div>
      </aside>

      <main className="main">
        <header className="topbar">
          <div>
            <div className="eyebrow">GYMERP</div>
            <h1>{title}</h1>
            <p>{subtitle}</p>
          </div>
          <div className="top-actions">
            {topbarActions}
            <button className="btn" onClick={doLogout} data-testid={IDS.logoutBtn}>
              <i className="fa-solid fa-right-from-bracket" /> Esci
            </button>
          </div>
        </header>
        <div className="content">{children}</div>
      </main>
    </div>
  );
}
